var React = require('react');

function ProgramMain2 (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"className":"path","strokeWidth":"5","stroke":"#fff","fill":"none","points":"226.883 0 0 0 0 90.418","key":0}),React.createElement("polyline",{"className":"dashed","fill":"none","stroke":"#1f355b","strokeWidth":"7","points":"226.883 0 0 0 0 90.418","key":1})]);
}

ProgramMain2.defaultProps = {"viewBox":"0 0 226.88326 90.41842"};

module.exports = ProgramMain2;

ProgramMain2.default = ProgramMain2;
